import React from "react";

import Typography from "@/components/Typography";
import moneyFormatter from "@/utils/moneyFormat";

import { CommonValueDiv, Container, FinalValueDiv, GeedeeValueDiv, LightValueDiv } from "./styles";
import { MonthCardProps } from "./types";

const MonthCard = ({ month, distributorPrice, price, lightPrice, discount }: MonthCardProps) => {
  const formatValue = (value: number | null) => {
    if (value === null || value <= 0) return "-";
    return moneyFormatter(value);
  };

  return (
    <Container>
      <div style={{}}>
        <Typography variant="btnSmall" color="primary500">
          {month}
        </Typography>
      </div>
      <div>
        <CommonValueDiv>
          <Typography variant="btnSmall" color="primary500">
            {formatValue(distributorPrice)}
          </Typography>
        </CommonValueDiv>
        <GeedeeValueDiv>
          <Typography variant="btnSmall" color="primary500">
            {formatValue(price)}
          </Typography>
        </GeedeeValueDiv>
        <LightValueDiv>
          <Typography variant="btnSmall" color="primary500">
            {formatValue(lightPrice)}
          </Typography>
        </LightValueDiv>
        <FinalValueDiv>
          <Typography variant="btnSmall" color="white">
            {formatValue(discount)}
          </Typography>
        </FinalValueDiv>
      </div>
    </Container>
  );
};

export default MonthCard;
